import { ChangeDetectionStrategy, Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'my-inbox-upload-file',
  templateUrl: './my-inbox-upload-file.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyInboxUploadFileComponent implements OnInit {
  origin = 'mobile';
  upload_file: any;
  dragged_data: any;
  suggestion_id: any;
  single_upload = false;

  dialogId;
  @Output() mxDialogMinimized = new EventEmitter<string>();
  constructor(@Inject(MAT_DIALOG_DATA) public data) {
    this.dialogId = data.dialogId;
  }
  ngOnInit(): void {
    this.origin = this.data?.origin ? this.data?.origin : 'mobile';
    this.upload_file = this.data?.upload_file;
    this.dragged_data = this.data?.dragged_data;
    this.suggestion_id = this.data?.suggestion_id;
    this.single_upload = this.data?.single_upload ? this.data?.single_upload : false;
  }
}
